import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {employeeRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {CreateEmployee} from './pages/CreateEmployee/CreateEmployee';
import {EmployeeDetail} from './pages/EmployeeDetail/EmployeeDetail';
import {EmployeeOverview} from './pages/EmployeeOverview/EmployeeOverview';
import {UserAbsenceOverview} from './pages/UserAbsenceOverview/UserAbsenceOverview';

export const EmployeeModule: Module = {
  id: moduleKeys.employee,
  alwaysShowContent: true,
  layoutProps: {
    title: 'module.employee.title',
    icon: 'sidebar/employee_management',
  },
  routerProps: {
    path: employeeRoutes.overview,
    element: <EmployeeOverview />,
  },
  requiredPermission: permissions.employeeRead,
  requiredFeatureFlag: featureFlags.EMPLOYEE_MANAGEMENT,
  content: [
    {
      id: 'employee-overview',
      routerProps: {
        path: employeeRoutes.overview,
        element: <EmployeeOverview />,
      },
      layoutProps: {
        title: 'Management',
        icon: 'sidebar/employee_management',
      },
    },
    {
      id: 'employee-user-absence-overview',
      requiredPermission: permissions.userAbsenceRead,
      requiredFeatureFlag: featureFlags.USER_ABSENCE,
      routerProps: {
        path: employeeRoutes.userAbsenceOverview,
        element: <UserAbsenceOverview />,
      },
      layoutProps: {
        title: 'user.awayStatus.awayBadge',
        icon: 'action/calendar_today',
      },
    },
    {
      id: 'employee-new',
      routerProps: {
        path: employeeRoutes.createEmployee,
        element: <CreateEmployee />,
      },
      requiredPermission: permissions.employeeRead,
      layoutProps: {
        title: 'page.createEmployee.labels.title',
        isPartOfCreateMenuItem: true,
      },
    },
    {
      id: 'employee-detail',
      routerProps: {
        path: employeeRoutes.detail,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-personalInfo',
      routerProps: {
        path: employeeRoutes.personalInfo,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-organizationalPlacement',
      routerProps: {
        path: employeeRoutes.organizationalPlacement,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-organizationalPlacement',
      routerProps: {
        path: employeeRoutes.externalSystems,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-externalAuthorizationSystems',
      routerProps: {
        path: employeeRoutes.externalAuthorizationSystems,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-userDataAndRoles',
      routerProps: {
        path: employeeRoutes.userDataAndRole,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-userAbsence',
      routerProps: {
        path: employeeRoutes.userAbsence,
        element: <EmployeeDetail />,
      },
      requiredFeatureFlag: featureFlags.USER_ABSENCE,
    },
    {
      id: 'employee-activityLogs',
      routerProps: {
        path: employeeRoutes.activityLogs,
        element: <EmployeeDetail />,
      },
    },
  ],
};
